import React from "react";
import HistoryLog from "modules/historyLog";

const HistoryLogPage = () => {
  return <HistoryLog />;
};

export default HistoryLogPage;
